/**
 * Whether the current org/user may select Uber Health as a vehicle type.
 * Mirrors HO_Rides / org addon checks; draft.isUberEnabled overrides when set on a ride copy.
 */
export function getOrgUberHealthEnabled({
  isUberEnabled,
  isUberEligibleFromAuth = false,
  user = null,
} = {}) {
  if (typeof isUberEnabled === 'boolean') {
    return isUberEnabled;
  }

  return Boolean(
    isUberEligibleFromAuth ||
      user?.isUberEligible ||
      user?.orgAddons?.uberHealthEnabled ||
      user?.organization?.addons?.uberHealthEnabled ||
      user?.addons?.uberHealthEnabled,
  );
}
